<template>
	<div class="md-grey-page center-horizontal">

		<div v-if="loading">
			<section class="container-white">
				Loading your info...
			</section>
		</div>

		<div v-if="!loading">
			<section class="container-white">
				<h1>{{contact.companyName}}</h1>
				<p class="text-left">
					Here is the personal information we hold for you:
				</p>
				<table class="tbl text-left">
					<tr>
						<th>Name</th>
						<td>{{contact.name}}</td>
					</tr>
					<tr v-if="contact.personalData.address1">
						<th>Address 1</th>
						<td>{{contact.personalData.address1}}</td>
					</tr>
					<tr v-if="contact.personalData.address2">
						<th>Address 2</th>
						<td>{{contact.personalData.address2}}</td>
					</tr>
					<tr v-if="ba && contact.email">
						<th>Email</th>
						<td>{{contact.email}}</td>
					</tr>
					<tr v-if="contact.personalData.emails">
						<th>Emails</th>
						<td v-html="multiple(contact.personalData.emails)"></td>
					</tr>
					<tr v-if="ba && contact.smsNumber">
						<th>Telephone</th>
						<td>{{contact.smsNumber}}</td>
					</tr>
					<tr v-if="contact.personalData.phones">
						<th>Telephone numbers</th>
						<td v-html="multiple(contact.personalData.phones)"></td>
					</tr>
					<tr v-if="contact.registrationDate">
						<th>Date you first registered with us</th>
						<td>{{registrationDate}}</td>
					</tr>
					<tr v-if="contact.personalData.role">
						<th>Registration type</th>
						<td>{{contact.personalData.role}}</td>
					</tr>
				</table>
				<p v-if="!ba" class="text-left">
					If you would like to change any of this information, please email <a :href="'mailto:' + contact.pointOfContact">{{contact.pointOfContact}}</a> with your request.
				</p>
			</section>

		</div>

	</div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
		ba: {
			type: Boolean,
			default: false
		}
	},
  data: function() {
    return {
		 contact: {},
		 loading: true
    }
  },
  created: async function() {
	  const that = this;

	  axios.get(`${this.config.services.gdpr}${this.ba ? '/ba' : ''}/contact/${this.$route.params.companyId}/${this.$route.params.contactId}`)
	  .then(function(response) {
		  that.contact = response.data.contact;
		  that.loading = false;
	  })
	  .catch(function(error) {
		  console.error('error:', error);
	  });
  },
  computed: {
	  registrationDate() {
		  const date = new Date(this.contact.registrationDate);
		  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
		  const month = monthNames[date.getMonth()]
		  let day = date.getDate();
		  day = day + (day > 0 ? ['th', 'st', 'nd', 'rd'][(day > 3 && day < 21) || day % 10 > 3 ? 0 : day % 10] : '');
		  const year = date.getFullYear();
		  return `${month} ${day}, ${year}`;
	  }
  },
  methods: {
	  multiple(str) {
		  return str.replace(/\[|\]/g, '').replace(/,/g, '<br/>');
	  }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/GDPRInfo.vue